/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Coffee',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M15.391 2.097c1.25 0 2.265 1.014 2.265 2.265v.182c1.075.176 1.895 1.109 1.895 2.233v.379c-.029.571-.425 1.066-1.017 1.126l-.385.006-1 13.092c-.023.295-.268.523-.564.523h-9.17l-.108-.011c-.245-.048-.436-.254-.456-.512L5.85 8.288h-.269a1.17 1.17 0 0 1-1.132-1.132v-.379c0-1.125.821-2.057 1.896-2.233v-.182c0-1.172.891-2.137 2.033-2.253l.231-.012h6.78zM7.813 18.239l.188 2.464h7.996l.188-2.464H7.813zm-.092-1.2h8.557l.431-5.644H7.29l.432 5.644zm-.523-6.844h9.603l.146-1.905H7.053l.146 1.905zm-.484-4.482c-.588 0-1.064.477-1.064 1.064v.311h12.701v-.311c0-.588-.477-1.064-1.064-1.064H6.714zM8.61 3.297c-.588 0-1.064.477-1.064 1.064v.145h8.909v-.145c0-.588-.477-1.064-1.065-1.064H8.61z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
